import { useState } from "react";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientEmployeesCard } from "@components/Cards";
import { ClientEmployeeViewMode } from "@components/Tables";

import { Tabs } from "@design-system/Tabs/Tabs";

import { PortalSubNavigationTabs } from "@layouts/PortalPage/PortalSubNavigationTabs";

import { routes } from "@pages/routes";

export const ClientEmployees = () => {
  const { clientId } = useTypedParams(
    routes.portal.clients.client.clientEmployees,
  );
  const [viewMode, setViewMode] = useState<ClientEmployeeViewMode>("active");

  return (
    <>
      <PortalSubNavigationTabs>
        <Tabs style={{ borderBottom: "none", gap: "24px" }}>
          <Tabs.Tab
            name="Active"
            isActive={viewMode === "active"}
            onClick={() => setViewMode("active")}
          />
          <Tabs.Tab
            name="Archived"
            isActive={viewMode === "archived"}
            onClick={() => setViewMode("archived")}
          />
        </Tabs>
      </PortalSubNavigationTabs>
      <ClientEmployeesCard clientId={clientId} viewMode={viewMode} />
    </>
  );
};
